module.exports = __webpack_public_path__ + "static/media/video.c8eb5c21.png";